import { render } from "./ChristmasOfferProgramBenefits.vue?vue&type=template&id=c285be70&scoped=true"
import script from "./ChristmasOfferProgramBenefits.vue?vue&type=script&lang=js"
export * from "./ChristmasOfferProgramBenefits.vue?vue&type=script&lang=js"

import "./ChristmasOfferProgramBenefits.vue?vue&type=style&index=0&id=c285be70&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c285be70"],['__file',"src/components/christmas-offer/ChristmasOfferProgramBenefits.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c285be70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c285be70', __exports__)) {
    console.log('reload')
    api.reload('c285be70', __exports__)
  }
  
  module.hot.accept("./ChristmasOfferProgramBenefits.vue?vue&type=template&id=c285be70&scoped=true", () => {
    console.log('re-render')
    api.rerender('c285be70', render)
  })

}


export default __exports__